<script>
import BarList from '../components/bar-list'
import ManifestoForm from './manifesto-form'
import ManifestoFiltro from '../components/manifesto-filtro'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';
import { apiORDSpost, apiORDSpostlongtimeout } from '../shared/api-functions'
import apiManifesto from '../api/api-manifesto'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            showList: true,
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            chNfe: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',

            query: {
                text: null,
                confdest: -1,
            },

            moreActionsBarList: [
                { action: 0, label: 'Pesquisar na receita novos registros' },
                { action: 1, label: 'Pesquisar na receita últimos 3 meses' },
                //{ action: 2, label: 'Teste timeout' },
            ],

            currentManifesto: {}
        }
    },

    components: {
        BarList, ManifestoForm, ManifestoFiltro

    },

    mixins:[apiManifesto],

    computed: {
        manifestoList: function () {
            return this.$store.getters.getManifestoList
        },
    },

    methods: {

        // getActionsManifesto (manifesto) {
        //     let list = []

        //     if (manifesto.confdest == '0'){
        //       list.push({ id: 0, text: 'Ciência da Operação' })
        //       list.push({ id: 1, text: 'Confirmação da Operação' })
        //       list.push({ id: 2, text: 'Confirmação da Operação, Download do XML e Gerar NF de Entrada' })
        //       list.push({ id: 3, text: 'Desconhecimento da Operação' } )
        //       list.push({ id: 4, text: 'Operação não realizada' } )
        //     }
        //     if (manifesto.confdest != '0' && (!manifesto.xml || manifesto.xml == '')){
        //       list.push({ id: 5, text: 'Carregar XML dos Servidores da Receita' })
        //     }
        //     if (manifesto.xml && manifesto.xml != ''){
        //       list.push({ id: 6, text: 'Gerar NF de Entrada por XML' })
        //     }
        //     if (manifesto.xml && manifesto.xml != ''){
        //       list.push({ id: 7, text: 'Download XML' })
        //     }
        //     return list
        // },

//deve habilitar todas as operacoes quando confdest==4
        getActionsManifesto (manifesto) {
            let list = []

            if (manifesto.confdest == '0' || manifesto.confdest == '4'){
              if (manifesto.confdest != '4')
                list.push({ action: 0, label: 'Ciência da Operação' })
              if (manifesto.confdest != '1')
                list.push({ action: 1, label: 'Confirmação da Operação' })
            //   list.push({ action: 2, label: 'Confirmação da Operação, Download do XML e Gerar NF de Entrada' })
              if (manifesto.confdest != '2')
                list.push({ action: 3, label: 'Desconhecimento da Operação' } )
              if (manifesto.confdest != '3')
                list.push({ action: 4, label: 'Operação não realizada' } )
            }
            if (manifesto.confdest != '0' && (!manifesto.xml || manifesto.xml == '')){
              list.push({ action: 5, label: 'Download do XML' })
            }
            if (manifesto.confdest == '1' && manifesto.xml && manifesto.xml != ''){
              list.push({ action: 6, label: 'Gerar NF de Entrada por XML' })
            }
            if (manifesto.xml && manifesto.xml != ''){
              list.push({ action: 7, label: 'Download do XML' })
            }
            return list
        },

        async teste_timeout(){
            var modulo = 'manifesto/timeout/'
            var sendData = {}
            sendData = { "teste": true }

            let metodo = 'post'

            const data = await apiORDSpostlongtimeout(this.$store, modulo, sendData, metodo)

            if (data.errmessages) {
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                this.$erpToastSuccess('Alguns erros precisam ser corrigidos.')
            }

        },

        changeFiltros (confdes) {
            // this.query.text = null
            this.query.confdest = confdes
            this.loadData()
        },

        descricaoEvento(tpevento){
            let status = tpevento;
            if (tpevento == '210210'){
                status = 'Ciencia da Operação'
            }
            if (tpevento == '210200'){
                status = 'Confirmação da Operação'
            }
            if (tpevento == '210220'){
                status = 'Desconhecimento da Operação'
            }
            if (tpevento == '210240'){
                status = 'Operação não Realizada'
            }
            return status;
        },



        statusManifesto(confdest){
            let statusmanifesto = 'Sem Manifestação';
            if (confdest == '1'){
                statusmanifesto = 'Confirmada Operação'
            }
            if (confdest == '2'){
                statusmanifesto = 'Desconhecida'
            }
            if (confdest == '3'){
                statusmanifesto = 'Operação não Realizada'
            }
            if (confdest == '4'){
                statusmanifesto = 'Ciente da Operação'
            }
            return statusmanifesto;
        },

        statusNFe(stnfe){
            let statusNFe = '';
            if (stnfe == '1'){
                statusNFe = 'Normal'
            }
            if (stnfe == '2'){
                statusNFe = 'Denegada'
            }
            if (stnfe == '3'){
                statusNFe = 'Cancelada'
            }
            return statusNFe;
        },


        async manifestoPesquisarA1(pesqapartirultimoregistro, pesqultimos15dias){
            var modulo = 'manifesto/pesquisar/'
            var sendData = {}
            sendData = { "pesqapartirultimoregistro": pesqapartirultimoregistro, "pesqultimos15dias": pesqultimos15dias }

            let metodo = 'post'

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)

            if (data.errmessages) {
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                this.query.confdest = -1;
                this.loadData()
                this.closeForm()
            }
        },

        manifestoPesquisarA3ResponseCallback(response) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message)
            } else {
                this.$erpToastSuccess('Pesquisa realizada')

            }
            this.loadData()
        },

        async manifestoPesquisarA3(pesqapartirultimoregistro, pesqultimos15dias){
            this.$appLoading(true);

            let sendData = "&pesqapartirultimoregistro="+pesqapartirultimoregistro+"&pesqultimos15dias="+pesqultimos15dias;
            this.$executaExtensaoChromeA3(null, 'manifestopesq', manifestoPesquisarA3ResponseCallback, sendData)
        },

        async handleAction(act) {

            if (act == 2) {
                this.teste_timeout()
            }

            let tipo = this.$certificadoCheck(null)
            if (tipo == 'A1') {
                if (act == 0) {
                    this.manifestoPesquisarA1(true, false)
                }else if (act == 1) {
                    this.manifestoPesquisarA1(false, true)
                }

            } else
            if (tipo == 'A3') {
                if (act == 0) {
                    this.manifestoPesquisarA3(true, false)
                }else if (act == 1) {
                    this.manifestoPesquisarA3(false, true)
                }

            }
        },

        handleEdit (chNfe, view) {
            //abre a tela de edicao

            if (view)
              this.crud = SysVars.crudView
            else
              this.crud = SysVars.crudU

            this.chNfe = chNfe
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
        },

        search(value) {
            //efetua a pesquisa
            this.query.text = value;
            this.query.confdest = -1;
            this.loadData()
        },

        async loadCurrentManifesto(manifesto) {
            //carrega o registro para alteracao ou visualizacao
            this.currentManifesto = null
            await this.$store.dispatch('loadManifesto', { id: manifesto.chnfe })
            if (this.$store.getters.getManifesto) {
                this.currentManifesto = { ...this.$store.getters.getManifesto }
                let self = this
                this.currentManifesto.list_manifesto.map(m => {
                    if (m.xml) {
                        self.currentManifesto.xml = m.xml
                    }
                })
            }
        },

        loadData() {
            this.filter = '';

            this.$store.commit('SET_INDEXFILTROTIPOSMANIFESTO', (this.query.confdest+1))

            if (this.query.confdest != -1){
                this.filter = this.filter + ((this.filter != '')? ',' : '') + '{"$and":[{"confdest":{"$eq":"' + this.query.confdest + '"}}]}'
            }
            if (this.query.text){
                this.filter = this.filter + ((this.filter != '')? ',' : '') + '{"$or":[{"emi_cnpjcpf":{"$like":"%25' + this.query.text + '%25"}},{"emi_nome":{"$like":"%25' + this.query.text + '%25"}},{"nrdoc":{"$like":"%25' + this.query.text + '%25"}},{"chnfe":{"$like":"%25' + this.query.text + '%25"}}]}'
            }

            var self = this

            // self.showList = false
            this.$store.dispatch('loadManifesto', { filter: this.filter } ).then(function (){
                self.showList = true
            })
        },

        async callbackManifesto(tipo, success, manifesto, codevento){
            if (success) {
              await this.loadData();
              if (codevento == '210210') {
                    //quando enviou evento de ciencia da operacao
                    if (manifesto.actmanifesto == 0)
                        this.handleActionManifesto(5, manifesto) //efetua o download do xml
              }
              if (codevento == '210200') {
                    //quando enviou evento de confirmacao da operacao
                    if (manifesto.actmanifesto == 2) { 
                        manifesto.gerar_nf = true
                        this.handleActionManifesto(2, manifesto) //download do xml e geracao da nf entrada no nb
                    } else {
                        this.handleActionManifesto(5, manifesto) //download do xml
                    }
              }
              if (!codevento && manifesto.gerar_nf){
                manifesto.actmanifesto = 6
                this.handleActionManifesto(6, manifesto)
              }
              if (manifesto.actmanifesto == 5) {
                //callback apos efetuar o download do xml da receita
                await this.loadCurrentManifesto(manifesto) //faz o load para checar se o xml foi baixado
                if (this.currentManifesto.xml) {
                    this.handleDownloadFile(this.currentManifesto)
                }
                else
                if (!this.currentManifesto.xml) {
                    let msg = null;
                    await this.currentManifesto.list_manifesto.map(m => {
                        if (m.msg) {
                            msg = m.msg
                        }
                    })
                    this.$erpToastError(msg)
                }
              }
            }
        },

        async handleActionManifesto(actionId, manifesto){
            let act = actionId

            await this.loadCurrentManifesto(manifesto)
            this.currentManifesto.actmanifesto = act

            if (act == 0) {
                //Ciência da Operação
                this.EnviarEvento(this.currentManifesto, '210210', 'Ciencia da Operacao', '', this.callbackManifesto);
            }
            if (act == 1) {
                //Confirmação da Operação
                this.EnviarEvento(this.currentManifesto, '210200', 'Confirmacao da Operacao', '', this.callbackManifesto);
            }
            if (act == 2) {
                //Confirmação da Operação, download e gerarNFxml
                this.EnviarEvento(this.currentManifesto, '210200', 'Confirmacao da Operacao', '', this.callbackManifesto);
            }
            if (act == 3) {
                //Desconhecimento da Operação
                this.EnviarEvento(this.currentManifesto, '210220', 'Desconhecimento da Operacao', '', this.callbackManifesto);
            }
            if (act == 4) {
                //Operação não realizada
                let ljust = prompt("Digite a justificativa porque a operação não foi realizada:", "");
                if (ljust != null && ljust != "") {
                   this.EnviarEvento(this.currentManifesto, '210240', 'Operacao nao Realizada', ljust, this.callbackManifesto);
                }
            }
            if (act == 5) {
                if (this.currentManifesto.xml)
                    this.handleDownloadFile(this.currentManifesto)
                else {
                    this.Downloadxml(this.currentManifesto, this.callbackManifesto);
                }
            }
            if (act == 6) {
                this.handleGerarNFXML(this.currentManifesto);
            }
            if (act == 7) {
                this.handleDownloadFile(this.currentManifesto);
            }
        },
    },


    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
                :refresh-button="true"
                :new-button="false"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Manifestação das Notas Recebidas"
                plural-entity="Manifestação das Notas Recebidas"
                :moreActions="moreActionsBarList"
                @action="handleAction"pesqultimos
                @search="search"
                @refresh="loadData"
                title-search="Pesquise pelo CNPJ, Nome ou pelo Nr. documento ">
            </bar-list>
            <br>
            <manifesto-filtro
                :query="query" @change="changeFiltros"></manifesto-filtro>
            <div class="default-container">
                <alert v-if="manifestoList.length == 0" type="norecord"></alert>
                <div class="mainbox-select" v-if="showList" v-for="(manifesto, index) in manifestoList" v-bind:key="index">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-6">
                                <label v-if="index == 0" class="lbl-list w-100">Número</label><span class="data-list">{{ manifesto.nrdoc }}</span>
                                <span v-if="manifesto.confdest == '1'" class="badge badge-green w-100 mb-2"> {{ statusManifesto(manifesto.confdest) }} </span>
                                <span v-if="manifesto.confdest == '0'" class="badge badge-yellow w-100 mb-2"> {{ statusManifesto(manifesto.confdest) }} </span>
                                <span v-if="manifesto.confdest == '4'" class="badge badge-blue w-100 mb-2"> {{ statusManifesto(manifesto.confdest) }} </span>
                                <span v-if="manifesto.confdest == '2'" class="badge badge-silver w-100 mb-2"> {{ statusManifesto(manifesto.confdest) }} </span>
                                <span v-if="manifesto.confdest == '3'" class="badge badge-silver w-100 mb-2"> {{ statusManifesto(manifesto.confdest) }} </span>
                                <span v-if="manifesto.stnfe == '2' || manifesto.stnfe == '3'" class="badge badge-red w-100 mb-2"> {{ statusNFe(manifesto.stnfe) }} </span>
                            </div>
                            <div class="col-md-2 col-6">
                                <label v-if="index == 0" class="lbl-list w-100">Data Documento</label><span class="data-list">{{ manifesto.dtdoc | formatData }}</span>
                            </div>
                            <div class="col-md-4 col-6" style="float: left">
                                <label v-if="index == 0" class="lbl-list w-100"> {{metadata.manifesto.emi_nome.label}} </label><span class="data-list">{{ manifesto.emi_nome }}</span>
                            </div>
                            <div class="col-md-2 col-6" style="float: left">
                                <label v-if="index == 0" class="lbl-list w-100"> {{metadata.manifesto.vnf.label}} </label><span class="data-list">{{ manifesto.vnf  | formatValue(2) }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                               <bar-grid
                                    :obj="manifesto"
                                    :options="{barDefault: true, btnView: true, btnEdit: false, barMANIFESTO: true}"
                                    :moreActions="getActionsManifesto(manifesto)" 
                                    @action="handleActionManifesto"
                                    v-on:view="handleEdit(manifesto.chnfe, true)">
                                </bar-grid>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-3 col-6" style="float: left">
                                <label class="lbl-list"> Evento </label><span class="data-list">{{ descricaoEvento(manifesto.tpevento) }}</span>
                            </div>
                            <div class="col-md-6 col-12" style="float: left">
                                <label class="lbl-list"> {{metadata.manifesto.chnfe.label}} </label><span class="data-list">{{ manifesto.chnfe }}</span>
                            </div>
                            <div class="col-md-3 col-6" style="float: left">
                                <label class="lbl-list"> {{metadata.manifesto.emi_cnpjcpf.label}} </label><span class="data-list">{{ manifesto.emi_cnpjcpf | formatCNPJCPF }}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <manifesto-form v-if="showForm" :index="this.chNfe" :crud="this.crud" v-on:closeform="closeForm"></manifesto-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/manifesto-list.vue